import { render, staticRenderFns } from "./bank_account.vue?vue&type=template&id=d1a5fa7c&"
import script from "./bank_account.vue?vue&type=script&lang=js&"
export * from "./bank_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports